import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.highlight()
  }

  highlight() {
    if (typeof hljs !== "undefined") {
      this.element.querySelectorAll("pre code").forEach((block) => {
        hljs.highlightElement(block)
      })
    } else {
      // Script may not have loaded yet during Turbo navigation
      setTimeout(() => this.highlight(), 100)
    }
  }
}
